import { CopilotPanelContentBase, CopilotPanelContext } from './copilotBridge';

// The copilot content of the audit scene: the audit being prepared. The backend recognises the
// context key of this usage and answers with the audit agent, which can plan the days and the
// assignments itself.
export class CopilotAuditPreparationContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.AuditPreparation;

  internalAuditId: number;

  // The audit's status (AuditStatus). Decides whether the findings analysis is offered: there is
  // nothing to analyse before the audit is being executed, and it stays available afterwards,
  // because findings can be managed after the audit is published.
  auditStatus?: number;

  constructor(internalAuditId: number, auditStatus?: number) {
    super();

    this.internalAuditId = internalAuditId;
    this.auditStatus = auditStatus;
  }
}
